import { render, staticRenderFns } from "./CouponVava.vue?vue&type=template&id=00c67c92&scoped=true"
import script from "./CouponVava.vue?vue&type=script&lang=js"
export * from "./CouponVava.vue?vue&type=script&lang=js"
import style0 from "./CouponVava.vue?vue&type=style&index=0&id=00c67c92&lang=less&scoped=true"
import style1 from "./CouponVava.vue?vue&type=style&index=1&id=00c67c92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c67c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c67c92')) {
      api.createRecord('00c67c92', component.options)
    } else {
      api.reload('00c67c92', component.options)
    }
    module.hot.accept("./CouponVava.vue?vue&type=template&id=00c67c92&scoped=true", function () {
      api.rerender('00c67c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCoupon/CouponVava.vue"
export default component.exports